import { FC } from 'react';
import type { TradeableTileData } from 'state/quotes/dashboard/model';

import { Price, PricingDate, ResultPanel, SolveModeLabel, StatusPanel, TileLayout } from './components';
import { AuthRefreshCountDown } from './components/result/AutoRefreshCountdown';
import { AutoRefreshProgress } from './components/result/AutoRefreshProgress';
import { StatusMessage } from './components/result/status';
import type { TileContentProps } from './Tile.common';

export const TradeableTile: FC<TileContentProps<TradeableTileData>> = ({ data, header, subHeader, footer }) => {
  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="info"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="small" />}
        price={
          <Price
            solveResult={data.solveResult}
            solveResultFormat={data.solveResultFormat}
            xMargin={data.xMargin}
            color="info"
            compactMode={false}
          />
        }
        progressBar={
          data.canTrade ? <AutoRefreshProgress color="info" timer={data.tradeAuth} isCountDown /> : undefined
        }
        subHeader={
          data.canTrade ? <AuthRefreshCountDown timer={data.tradeAuth} /> : <PricingDate when={data.lastUpdated} />
        }
        statusPanel={
          data.canTrade && (
            <StatusPanel className="alert alert-discreet-info">
              <StatusMessage msgKey="dashboard.tradable" iconWorkaround="verified_user_outlined" />
            </StatusPanel>
          )
        }
      />
    </TileLayout>
  );
};

TradeableTile.displayName = 'TradeableTile';
